import React from 'react';
import { useParams } from 'react-router-dom';
import ReportViewShell from '../components/reports/view/ReportViewShell';

const ReportViewPage = () => {
  const { id } = useParams();
  return <ReportViewShell reportId={id} />;
};

export default ReportViewPage;
